<!--
// nuxt-ui/pages/Tournament.vue
-->
<script setup lang="ts">
import LayoutTournamentKwcClubs from "~/nuxt-ui/components/pages/region-tournament/LayoutTournamentKwcClubs.vue";
import { useRegions } from "~/nuxt-ui/Shared/composables/regions";
import LayoutTournamentKwcNations from "~/nuxt-ui/components/pages/region-tournament/LayoutTournamentKwcNations.vue";

const { t } = useI18n();
const { isWorldCup, isNations } = useRegions();

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: "/[region]/tournament",
    es: "/[region]/torneo",
    de: "/[region]/turnier",
    fr: "/[region]/tournoi",
    it: "/[region]/torneo",
    pt: "/[region]/campeonato",
  },
});

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-spain",
    "not-found-queens",
    "not-found-italy",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
  ],
});

useSeoMeta({
  title: t("header.navCompetition.tournament"),
  ogTitle: t("header.navCompetition.tournament"),
});
</script>

<template>
  <layout-tournament-kwc-clubs v-if="isWorldCup"></layout-tournament-kwc-clubs>
  <layout-tournament-kwc-nations v-else-if="isNations"></layout-tournament-kwc-nations>
  <section v-else></section>
</template>

<style scoped>
strong {
  @apply font-black;
}
</style>
